import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";

type Props = {
  open: boolean;
  onToggle: () => void;
  value: string;
  onChange: (value: string) => void;
  onApply: () => void;
  onReset: () => void;
  onFormat: () => void;
  onCopy: () => void;
};

export default function PlatformAutomationAdvancedJson({
  open,
  onToggle,
  value,
  onChange,
  onApply,
  onReset,
  onFormat,
  onCopy,
}: Props) {
  const lineCount = useMemo(
    () => Math.max(value.split("\n").length, 1),
    [value]
  );

  return (
    <section className={`pa-advanced ${open ? "is-open" : ""}`}>
      <button
        type="button"
        className="pa-advanced__toggle"
        onClick={onToggle}
        aria-expanded={open}
      >
        <div className="pa-advanced__toggle-copy">
          <span className="pa-advanced__icon" aria-hidden="true">
            <FontAwesomeIcon icon={["fas", "code"]} />
          </span>
          <div>
            <strong>
              <FormattedMessage id="app.platformAutomations.editor.advancedJson" />
            </strong>
            <span>
              <FormattedMessage id="app.platformAutomations.editor.advancedJsonHint" />
            </span>
          </div>
        </div>
        <FontAwesomeIcon
          icon={["fas", open ? "chevron-up" : "chevron-down"]}
          className="pa-advanced__chevron"
        />
      </button>

      {open && (
        <div className="pa-advanced__body">
          <div className="pa-advanced__editor-shell">
            <div className="pa-advanced__editor-meta">
              <span>
                <FormattedMessage
                  id="app.platformAutomations.editor.advancedJsonLines"
                  values={{ count: lineCount }}
                />
              </span>
            </div>
            <div className="pa-advanced__editor">
              <textarea
                className="pa-advanced__textarea"
                spellCheck={false}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                aria-label="JSON del flujo"
              />
            </div>
          </div>

          <div className="pa-advanced__actions">
            <button
              type="button"
              className="email-mkt__primary-btn"
              onClick={onApply}
            >
              <FormattedMessage id="app.platformAutomations.editor.applyJson" />
            </button>
            <button
              type="button"
              className="email-mkt__ghost-btn"
              onClick={onFormat}
            >
              <FormattedMessage id="app.platformAutomations.editor.formatJson" />
            </button>
            <button
              type="button"
              className="email-mkt__ghost-btn"
              onClick={onCopy}
            >
              <FormattedMessage id="app.platformAutomations.editor.copyJson" />
            </button>
            <button
              type="button"
              className="email-mkt__ghost-btn"
              onClick={onReset}
            >
              <FormattedMessage id="app.platformAutomations.editor.resetJson" />
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
